module.exports = __webpack_public_path__ + "static/media/9@3x.6a5271a3.png";